<template>
  <BaseInput
    :model-value="props.modelValue"
    :mask="isPhone ? MASK_OF_PHONE_OR_EMAIL : undefined"
    placeholder="+7 999-999-99-99"
    :with-full="props.withFull"
    :readonly="props.readonly"
    @get-unmasked-value="handleChangeUnmaskedValue($event as string)"
    @click="handleClick"
  />
</template>

<script setup lang="ts">
import { MASK_OF_PHONE_OR_EMAIL } from '../../const/masks'
import { REGEX_FOR_MASK_PHONE } from '../../const/regex'
import { changeToCorrectNumber } from '../../lib/input/phone'
import { callPhone } from '../../lib/text/phone'
import BaseInput from '../input/index.vue'

interface Props {
  modelValue: string
  withFull?: boolean
  readonly?: boolean
}

const props = defineProps<Props>()
const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void
}>()
const isPhone = computed(() => /^\d+/.test(props.modelValue))

function handleChangeUnmaskedValue(value: string) {
  if (value.at(0) === '+') {
    value = (value as string).slice(1)
  }
  if (REGEX_FOR_MASK_PHONE.test(value as string)) {
    value = (value as string).replace(/\D/g, '').slice(1)
  }
  emit(
    'update:modelValue',
    isPhone.value ? changeToCorrectNumber(value) : value,
  )
}

function handleClick() {
  if (props.readonly && props.modelValue && isPhone.value) {
    callPhone(props.modelValue)
  }
}
</script>
